<template>
    <div class="flex flex-col items-center">
        <div v-if="!hideBorder" class="w-full border-t pb-40"></div>
        <div class="w-4/5">
            <div class="grid grid-cols-3 gap-16">
                <div class="flex flex-col items-center">
                    <div class="discovery-icon">
                        <svg-icon class="w-32 h-32 discovery-icon-color" type="hub"></svg-icon>
                    </div>
                    <div class="py-16">
                        <h3 class="text-center discovery-header">{{ $t('settings.integrations.multi-posting.header3.title')}}</h3>
                        <p class="text-center">{{ $t('settings.integrations.multi-posting.header3.description') }}</p>
                    </div>
                </div>
                <div class="flex flex-col items-center">
                    <div class="discovery-icon">
                        <svg-icon class="w-32 h-32 discovery-icon-color" type="schedule"></svg-icon>
                    </div>
                    <div class="py-16">
                        <h3 class="text-center discovery-header">{{ $t('settings.integrations.multi-posting.header2.title')}}</h3>
                        <p class="text-center">{{ $t('settings.integrations.multi-posting.header2.description') }}</p>
                    </div>
                </div>
                <div class="flex flex-col items-center">
                    <div class="discovery-icon">
                        <svg-icon class="w-32 h-32 discovery-icon-color" type="groups-2"></svg-icon>
                    </div>
                    <div class="py-16">
                        <h3 class="text-center discovery-header">{{ $t('settings.integrations.multi-posting.header1.title') }}</h3>
                        <p class="text-center">{{ $t('settings.integrations.multi-posting.header1.description') }}</p>
                    </div>
                </div>
            </div>
            <div class="mt-32">
                <div class="flex justify-between">
                    <p class="font-semibold">{{ $t('settings.integrations.multi-posting.products.title') }}</p>
                </div>
                <div>
                    <p>{{ $t('settings.integrations.multi-posting.products.description') }}</p>
                </div>
                <div class="flex flex-wrap gap-16 justify-center items-center pt-28 pb-40">
                    <div v-for="index in productCount" class="size-80">
                        <img class="w-full aspect-square rounded-full shadow" :src="productImg(index)" alt="logo">
                    </div>
                    <div class="rounded-full shadow bg-white size-80">
                        <div class="size-full flex items-center justify-center">
                            <p class="font-semibold">+3864</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!hideActivateButton" class="flex justify-end gap-8 w-full">
            <simple-button
                look="text"
                :loading="requestingContact"
                @click="$emit('contact')"
            >
                {{ $t('multi-posting.integrations.contact')}}
            </simple-button>
            <simple-button
                look="primary"
                :loading="requestingQuote"
                @click="$emit('request')"
            >
                {{ $t('multi-posting.integrations.request_qoute') }}
            </simple-button>
        </div>
    </div>
</template>

<script>
import SimpleButton from "../ui/SimpleButton.vue";
import SvgIcon from '../ui/SvgIcon.vue';

export default {
    name: 'MultiPostingCollapse',
    components: { SimpleButton, SvgIcon },
    props: {
        hideBorder: {
            type: Boolean,
            default: false
        },
        hideActivateButton: {
            type: Boolean,
            default: false
        },
        requestingQuote: {
            type: Boolean,
            default: false
        },
        requestingContact: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            productCount: 5,
        }
    },
    methods: {
        productImg(index) {
            return `/app/img/integrations/vonq/ProductLogo-${index}.svg`;
        }
    }
};
</script>

<style scoped>
.discovery-header {
    @apply font-semibold;
}

.discovery-icon {
    @apply bg-primary-20 p-16 rounded-4;
}

.discovery-icon-color {
    @apply fill-primary;
}
</style>